import { USER_CLUB_JOIN_STATUS } from 'App/constants'
import appActions from 'App/duck/actions'
import { operationFetchSettings, operationFetchUser } from 'App/duck/operations'
import { operationSetJoinClubModalVisibility } from 'features/account/hub/duck/operations'
import { operationGetVouchers } from 'features/vouchers/duck/operations'

import { fetchProvinces, upgradeUserToClub } from '../requests'
import {
  fetchProvincesStart,
  fetchProvincesSuccess,
  fetchProvincesFail,
  postUpgradeToClubStart,
  postUpgradeToClubSuccess,
  postUpgradeToClubFail,
} from './actions'

// xx  - refactor later - Dispatch() is synchronous and doesn't return a promise
export const operationRefreshUserOnSuccessAndCloseModal = () => (dispatch) => {
  dispatch(operationFetchSettings())
  dispatch(operationFetchUser())
  dispatch(operationGetVouchers())
  dispatch(appActions.updateUser({ status: USER_CLUB_JOIN_STATUS.FULL_MEMBER }))
  dispatch(operationSetJoinClubModalVisibility(false))
}

export const operationFetchProvinces = () => (dispatch) => {
  dispatch(fetchProvincesStart())

  return fetchProvinces()
    .then((result) => {
      dispatch(fetchProvincesSuccess(result))
    })
    .catch((err) => dispatch(fetchProvincesFail(err)))
}

export const operationUpgradeAndUpdateState = (data) => (dispatch) => {
  dispatch(postUpgradeToClubStart())
  return upgradeUserToClub(data)
    .then(() => {
      dispatch(postUpgradeToClubSuccess())
      dispatch(operationRefreshUserOnSuccessAndCloseModal())
    })
    .catch((error) => {
      dispatch(postUpgradeToClubFail(error.message))
    })
}
